import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { PostHogProvider } from "posthog-js/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { config } from "./config/env.ts";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <PostHogProvider
      apiKey={config.publicPosthogKey}
      options={{
        api_host: "https://us.i.posthog.com",
        // debug: import.meta.env.MODE === "development",
      }}
    >
      <App />
    </PostHogProvider>
  </QueryClientProvider>,
);
